import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import mapboxgl from "mapbox-gl";
// import { places } from "../../mock/data";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import {
  Card,
  CardContent,
  CardHeader,
  Grid,
  Typography,
  Tabs,
  Tab,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Switch,
  FormControlLabel,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Fab,
  IconButton
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PersonIcon from "@mui/icons-material/Person";
import DevicesIcon from "@mui/icons-material/Devices";
import PlaceIcon from "@mui/icons-material/Place";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { useMaterialUIController } from "context";
import LocalOfferIcon from "@mui/icons-material/LocalOffer"; // Example “tag” icon
import isMock from "../../config";
import {MoreVert} from "@mui/icons-material";
import {MaterialReactTable} from "material-react-table";

mapboxgl.accessToken =
    "pk.eyJ1IjoibGVvbnRvbWVyIiwiYSI6ImNtNTVjeTdwcTJ3em4yanNkeHg3eDNhaW0ifQ.3Tg0RL9HhK4yQRzVpMMB1Q";

function PlaceDetails() {
  const { id } = useParams();
  const [lngLat, setLngLat] = useState(null);
  const mapContainerRef = useRef(null);
  const mapRef = useRef(null);
  const [lrName, setLrName] = useState("");
  const [lrMembersOnly, setLrMembersOnly] = useState(false);
  const [lrGuestsOnly, setLrGuestsOnly] = useState(false);
  const [lrGroup, setLrGroup] = useState("");
  const [lrOperation, setLrOperation] = useState("block");
  const [orgOption, setOrgOption] = useState("");
  const [lrLanes, setLrLanes] = useState(1);
  const [socketLog, setSocketLog] = useState([]);
  // Main tabs (General / Log / Users / Places / Settings):
  const [selectedTab, setSelectedTab] = useState(0);
  const [typeValue, setTypeValue] = useState("LPR PARK PAYMENT");
  const [allOrgs, setAllOrgs] = useState([]);
  const [freeTimeHours, setFreeTimeHours] = useState(0);
  const [freeTimeMinutes, setFreeTimeMinutes] = useState(0);
  // const [subPlaces, setSubPlaces] = useState([]);
  const [addUserDialogOpen, setAddUserDialogOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [showCarsDialogOpen, setShowCarsDialogOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
// Temporary storage for creating a new user
  const [newUser, setNewUser] = useState({
    placeId: id,
    phoneNumber: "",
    firstName: "",
    lastName: "",
    carsLimit: 10,
    notes: "",
    cars: [],      // array of objects { id, color, brand, model, match }
    idNumber: "999999999"
  });

//{"did":"LPR100100764","placeId":"8d901d5d-1017-4c94-b156-7a6ec0680467","uid":"10007784376006","guest":true,"tm":1740300415,"approved":true,"carId":"80821301","direction":"IN","reason":"free time","inTime":1740300415,"laneUuid":"318c3d80-b9f9-43d9-a591-ecb5b9a9ab5c"}
  const socket = new WebSocket('wss://logs.bluept.dev');
  const searchRowRecursively = (row, columnId, filterValue) => {
    const value = row.getValue(columnId);
    if (value?.toLowerCase().includes(filterValue.toLowerCase())) {
      return true;
    }
    if (row.subPlaces?.length) {
      return row.subPlaces.some((subRow) => searchRowRecursively(subRow, columnId, filterValue));
    }
    return false;
  };

  socket.addEventListener('open', function (event) {
    console.log('WebSocket is open now.');
  });

  socket.addEventListener("message", function (event) {
    try {
      const parsedData = JSON.parse(event.data);
      console.log(event.data);
      console.log(parsedData.placeId, place.placeId, place);

      // Only keep messages where placeId matches our current place
      if (parsedData.placeId === place.placeId) {
        console.log("Message from server ", parsedData);

        // Update React state with the new message
        if (parsedData.placeId === place.placeId) {
          setSocketLog((prev) => {
            // Decide how you define uniqueness:
            const isDuplicate = prev.some(
                (log) =>
                    log.tm === parsedData.tm &&
                    log.uid === parsedData.uid &&
                    log.direction === parsedData.direction &&
                    log.carId === parsedData.carId &&
                    log.inTime === parsedData.inTime &&
                    log.reason === parsedData.reason
                // optionally add more fields here, e.g. log.carId === parsedData.carId, etc.
            );

            // If it's already in the array, skip it
            if (isDuplicate) {
              return prev;
            }

            // Otherwise, add the new entry
            return [parsedData, ...prev];
          });
        }      }
    } catch (error) {
      console.error("Error parsing WebSocket message:", error);
    }
  });

// State for Add Car mini-dialog
  const [addCarDialogOpen, setAddCarDialogOpen] = useState(false);

// Temporary storage for one car to be added
  const [newCar, setNewCar] = useState({
    licensePlate: "",
    color: "",
    brand: "",
    model: "",
  });
  const [laneRulesRows, setLaneRulesRows] = useState([
    {
      id: 1,
      name: "משרדי טכנוסו כניסה 101",
      membersOnly: true,
      guestsOnly: true,
      group: "",
      operation: "ignoreGraceTimeIn",
      authorizedLanes: 1
    },
    {
      id: 2,
      name: "משרדי טכנוסו כניסה 101",
      membersOnly: false,
      guestsOnly: true,
      group: "",
      operation: "block",
      authorizedLanes: 3
    }
  ]);
  const [laneRulesDialogOpen, setLaneRulesDialogOpen] = useState(false);
  const initialTicketsData = [
    {
      id: "3000020000786582",
      type: "amount",
      value: 10,
      groupId: "1",
      lastUsed: "18/01/2025 - 16:17:28",
    },
    {
      id: "3000020000786583",
      type: "amount",
      value: 10,
      groupId: "1",
      lastUsed: "21/01/2025 - 16:29:20",
    },
    {
      id: "3000020000786584",
      type: "amount",
      value: 10,
      groupId: "1",
      lastUsed: "21/01/2025 - 16:29:20",
    },
    {
      id: "3000020004160838",
      type: "amount",
      value: 1,
      groupId: "2",
      lastUsed: "05/12/2024 - 15:52:54",
    },
    {
      id: "3000020000453352",
      type: "amount",
      value: 1,
      groupId: "2",
      lastUsed: "05/12/2024 - 15:52:54",
    },
    {
      id: "3000020010046486",
      type: "percentage",
      value: 100,
      groupId: "3",
      lastUsed: "05/12/2024 - 15:52:54",
    },
  ];
  const [ticketsRows, setTicketsRows] = useState(initialTicketsData);
  const [ticketsSearch, setTicketsSearch] = useState("");
  // Sub-tabs for the Settings tab:
  const [settingsTab, setSettingsTab] = useState(0);

  // For Places
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredPlaces, setFilteredPlaces] = useState([]);

  useEffect(()=>
      {
        (async function getPlaceById () {
          const response = await fetch(
              `http://localhost:3001/places/${id}`
          );
          if (!response.ok) {
            throw new Error("Failed to fetch places");
          }
          const data = await response.json();
          console.log(data);
          if((isMock && data?.organizationId) || !isMock) {
            const org = await fetch(
                `http://localhost:3001/organizations/${isMock ? data?.organizationId : data?.place?.organizationId}`
            );
            const orgData = await org.json();
            console.log('orgData', orgData);
            setOrganization([isMock ? orgData : orgData.organization]);

            //  console.log('orgData.organization.name', orgData.organization.name);
            setOrgOption(isMock ? orgData.id : orgData.organization.id);
          }
          setPlace(isMock ? data : data.place);
          const userRes = await fetch(`http://localhost:3001/users?placeId=${id}`);
          const userData = await userRes.json();
          setUsers(isMock ? userData : userData.parkingUsers);
          setFilteredPlaces(isMock ? data.subPlaces : data.place.subPlaces);
          setFreeTimeHours(Math.floor((isMock ? data?.settings?.freeTime || 0 : data.place?.settings?.freeTime || 0)/60) );
          setFreeTimeMinutes((isMock ? data?.settings?.freeTime || 0 : data.place?.settings?.freeTime || 0) % 60)
          setParkingSettings(isMock ? data?.settings : data.place.settings);
        })();
      }
      ,[]);


  // For Organizations (example from previous code)
  const [orgRows, setOrgRows] = useState([
    {
      id: 605,
      name: "Technoso control systems LTD",
      address: "הקישון 6, Yavne, Israel",
    },
    {
      id: 615,
      name: "lagoon2",
      address: "בן גוריון 3, Netanya, Israel",
    },
  ]);

  // For Devices (new!)
  const [devicesRows, setDevicesRows] = useState([
    {
      id: 1,
      serialNumber: "LPR100100744",
      model: "",
      name: "מערכת מצלמות - חניון לגון 2",
      address: "יוסף ליפיד 3, נתניה",
      lanes: 2,
    },
  ]);
  const [devicesSearch, setDevicesSearch] = useState("");
  const [devicesDialogOpen, setDevicesDialogOpen] = useState(false);
  const handleSaveSettings = async () =>{
    const newParkingSettings = {...parkingSettings};
    newParkingSettings.freeTime = freeTimeHours * 60 + freeTimeMinutes;
    setParkingSettings({...newParkingSettings});
    await fetch(
        `http://localhost:3001/places/${id}`,{
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({...place, settings: newParkingSettings})
        }
    );
  }
  // Fields for new/edit Device
  const [deviceSerial, setDeviceSerial] = useState("");
  const [deviceModel, setDeviceModel] = useState("");
  const [deviceName, setDeviceName] = useState("");
  const [deviceAddress, setDeviceAddress] = useState("");
  const [deviceLanes, setDeviceLanes] = useState("");

  const [orgDialogOpen, setOrgDialogOpen] = useState(false);
  const [orgName, setOrgName] = useState("");
  const [orgAddress, setOrgAddress] = useState("");
  const [orgId, setOrgId] = useState("");

  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [parkingSettings, setParkingSettings] = useState({});
  const [placesData, setPlacesData] = useState([]);
  const [organization, setOrganization] = useState([]);
  const [newPlaceName, setNewPlaceName] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [tariffsRows, setTariffsRows] = useState([
    {
      id: 461,
      name: "DAY",
      start: "00:00:00",
      end: "00:00:00",
      days: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]
    }
  ]);
  const [tariffsDialogOpen, setTariffsDialogOpen] = useState(false);

  // Fields for new or edited tariff
  const [tariffName, setTariffName] = useState("");
  const [tariffId, setTariffId] = useState("");
  const [tariffStart, setTariffStart] = useState("");
  const [tariffEnd, setTariffEnd] = useState("");
  const [tariffDays, setTariffDays] = useState(["Mo","Tu","We","Th","Fr"]);
  const [place, setPlace] = useState({});
  const handleDevicesSearchChange = (e) => {
    setDevicesSearch(e.target.value);
  };

  const filteredDevices = devicesRows.filter((dev) => {
    const term = devicesSearch.trim().toLowerCase();
    if (!term) return true;
    return (
        dev.serialNumber.toLowerCase().includes(term) ||
        dev.model?.toLowerCase().includes(term) ||
        dev.name?.toLowerCase().includes(term) ||
        dev.address?.toLowerCase().includes(term)
    );
  });
  const handleAddDeviceClick = () => {
    setDeviceSerial("");
    setDeviceModel("");
    setDeviceName("");
    setDeviceAddress("");
    setDeviceLanes("");
    setDevicesDialogOpen(true);
  };
  const handleSaveDevice = () => {
    if (!deviceSerial.trim()) {
      alert("Serial Number is required.");
      return;
    }
    const newId = devicesRows.length > 0 ? devicesRows[devicesRows.length - 1].id + 1 : 1;
    const newDevice = {
      id: newId,
      serialNumber: deviceSerial,
      model: deviceModel || "",
      name: deviceName || "",
      address: deviceAddress || "",
      lanes: deviceLanes || 0,
    };
    setDevicesRows([...devicesRows, newDevice]);
    setDevicesDialogOpen(false);
  };

  // -----------
  // Handlers
  // -----------
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleSettingsTabChange = (event, newValue) => {
    setSettingsTab(newValue);
  };

  // const findPlaceById = (places, id) => {
  //   for (const place of places) {
  //     if (place.id === id) {
  //       return place;
  //     }
  //     if (place.subRows) {
  //       const result = findPlaceById(place.subRows, id);
  //       if (result) {
  //         return result;
  //       }
  //     }
  //   }
  //   return null;
  // };

  // Add new Organization
  const handleAddOrgClick = () => {
    setOrgName("");
    setOrgAddress("");
    setOrgId("");
    setOrgDialogOpen(true);
  };

  // Save new or updated Org
  const handleSaveOrg = async () => {
    const newPlace = {...place};
    newPlace.organizationId = orgOption;
    setPlace(newPlace);
    const org = await fetch(
        `http://localhost:3001/organizations/${orgOption}`
    );
    const orgData = await org.json();
    console.log('orgData', orgData);
    setOrganization([isMock ? orgData : orgData.organization]);
    await fetch(
        `http://localhost:3001/places/${id}`,{
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(newPlace)
        }
    );
    setOrgDialogOpen(false);
  };

  // Delete an organization
  // const handleDeleteOrg = async () => {
  //   const newPlace = {...place};
  //   newPlace.organizationId = "";
  //   setPlace(newPlace);
  //   await fetch(
  //       `http://ec2-51-17-165-3.il-central-1.compute.amazonaws.com:8080/api/v1/places/${id}`,{
  //         method: 'PUT',
  //         headers: {
  //           'Content-Type': 'application/json',
  //         },
  //         body: JSON.stringify(newPlace)
  //       }
  //   );  };

  // Edit an existing organization
  const handleEditOrg = async (row) => {
    const allOrgs =  await fetch("http://localhost:3001/organizations");
    const orgs = await allOrgs.json();
    setAllOrgs(isMock ? orgs : orgs.organizations.data);
    if(row) {
      setOrgName(row.name);
      setOrgAddress(row.address);
      setOrgId(String(row.id));
    }
    setOrgDialogOpen(true);
  };

  // useEffect(() => {
  //   // Simulate fetching places under the current place
  //   const fetchedPlaces = [
  //     { id: "1", name: "Place A", address: "Netanya, Israel", devices: 2 },
  //     { id: "2", name: "Place B", address: "Tel Aviv, Israel", devices: 0 },
  //     { id: "3", name: "Place C", address: "Haifa, Israel", devices: 1 },
  //   ];
  //   setPlacesData(fetchedPlaces);
  //   setFilteredPlaces(fetchedPlaces);
  // }, []);

  // const place = places ? findPlaceById(places, id) : null;



  // Get coordinates from Mapbox
  useEffect(() => {
    if (Object.keys(place).length > 0) {
      console.log(place);
      const fetchCoordinates = async () => {
        try {
          const response = await fetch(
              `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
                  place.address
              )}.json?access_token=${mapboxgl.accessToken}`
          );
          const data = await response.json();
          console.log('data:::', data);



          if (data.features && data.features.length > 0) {
            const [longitude, latitude] = data.features[0].center;
            setLngLat({ longitude, latitude });
          }
        } catch (error) {
          console.error("Geocoding error:", error);
        }
      };
      fetchCoordinates();
    }
  }, [place]);

  // Initialize/flyTo the map
  useEffect(() => {
    if (!lngLat || !mapContainerRef.current) return;

    if (!mapRef.current) {
      mapRef.current = new mapboxgl.Map({
        container: mapContainerRef.current,
        style: "mapbox://styles/mapbox/satellite-streets-v11",
        center: [lngLat.longitude, lngLat.latitude],
        zoom: 15,
      });

      new mapboxgl.Marker()
          .setLngLat([lngLat.longitude, lngLat.latitude])
          .addTo(mapRef.current);
    } else {
      mapRef.current.flyTo({
        center: [lngLat.longitude, lngLat.latitude],
        zoom: 15,
      });
    }
    if (selectedTab === 0) {
      // Force map to resize
      mapRef.current.resize();
    }
  }, [lngLat, selectedTab]);

  if (!place) {
    return <div>Place not found.</div>;
  }

  // Searching places
  const handleSearchChange = (e) => {
    const term = e.target.value;
    if(e.target.value.length === 0)
        setFilteredPlaces(place.subPlaces);
    setSearchTerm(term);

    const filtered = e.target.value.length === 0 ?
        place.subPlaces.filter(
        (p) =>
            p.name.toLowerCase().includes(term.toLowerCase())
    )
        :
        filteredPlaces.filter(
        (p) =>
            p.name.toLowerCase().includes(term.toLowerCase())
    );
    setFilteredPlaces(filtered);
  };

  const renderSettingsDevices = () => {
    const devicesColumns = [
      {
        accessorKey: "serialNumber",
        header: "Serial Number",
        Cell: ({ cell }) => (
            <Typography
                sx={{ color: "#2196f3", textDecoration: "underline", cursor: "pointer" }}
            >
              {cell.getValue()}
            </Typography>
        ),
      },
      {
        accessorKey: "model",
        header: "Model",
      },
      {
        accessorKey: "name",
        header: "Name",
      },
      {
        accessorKey: "address",
        header: "Address",
      },
      {
        accessorKey: "lanes",
        header: "Lanes",
      },
    ];
    return (
        <Box sx={{ p: 2, position: "relative" }}>

          {/* + button in top right */}
          <Box sx={{ position: "absolute", top: 16, right: 16 }}>
            <Fab color="primary" size="medium" onClick={handleAddDeviceClick}>
              <AddIcon />
            </Fab>
          </Box>

          {/* Table of devices */}
          <Card sx={{ mt: 2, backgroundColor: cardBgColor }}>
            <CardContent>
              <Box sx={{ height: 400, width: "100%" }}>
                <MaterialReactTable
                    data={place.devices || []}
                    columns={devicesColumns}
                    enableGlobalFilter
                    muiBottomToolbarProps={{
                      sx: {
                        backgroundColor: darkMode ? '#1e293b' : '#fff',
                        color: darkMode ? '#fff' : '#1e293b',
                        ".MuiFormLabel-root": { color: darkMode ? '#fff' : '#1e293b' },
                        ".MuiSelect-icon": { color: darkMode ? '#fff' : '#1e293b' },
                        ".MuiSelect-select": { color: darkMode ? '#fff' : '#1e293b' },
                        ".MuiBox-root.MuiButtonBase-root": { color: darkMode ? '#fff' : '#1e293b' },
                        ".MuiSvgIcon-root": { color: darkMode ? '#fff' : '#1e293b' },
                        '& .MuiButtonBase-root.Mui-disabled .MuiSvgIcon-root': {
                          color: darkMode ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
                        },
                      },
                    }}
                    muiTopToolbarProps={{
                      sx: {
                        backgroundColor: darkMode ? '#1e293b' : '#fff',
                        color: '#fff',
                        ".MuiSvgIcon-root": { color: darkMode ? '#fff' : '#1e293b' },
                        ".MuiTableSortLabel-iconDirectionAsc": { color: darkMode ? '#fff' : '#1e293b' },
                        '& .MuiInputBase-input': { color: darkMode ? '#fff' : '#1e293b' },
                      },
                    }}
                    muiTableBodyCellProps={{
                      sx: {
                        backgroundColor: darkMode ? "#1e293b" : "#ffffff",
                        color: darkMode ? "#ffffff" : "#000",
                        ".MuiSvgIcon-root": { color: darkMode ? "#ffffff" : "#000" },
                      },
                    }}
                    muiTableHeadCellProps={{
                      sx: {
                        backgroundColor: darkMode ? "#1e293b" : "#0098CF",
                        color: darkMode ? "#ffffff" : "#000",
                        fontWeight: "bold",
                        ".MuiSvgIcon-root": { color: darkMode ? "#ffffff" : "#000" },
                        '& .MuiTableSortLabel-icon': {
                          color: darkMode ? '#fff !important' : '#000 !important',
                        },
                        '& .MuiTableSortLabel-iconDirectionAsc': {
                          color: darkMode ? '#fff !important' : '#000 !important',
                        },
                        '& .MuiTableSortLabel-iconDirectionDesc': {
                          color: darkMode ? '#fff !important' : '#000 !important',
                        },
                        '& .MuiButtonBase-root.Mui-disabled .MuiSvgIcon-root': {
                          color: darkMode ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
                        },
                        '& .MuiInputBase-input': {
                          color: darkMode ? '#fff' : '#1e293b',
                        },
                      },
                    }}
                    globalFilterFn="recursiveSearch"
                    filterFns={{
                      recursiveSearch: (row, columnId, filterValue) =>
                          searchRowRecursively(row, columnId, filterValue),
                    }}
                    muiTableHeadProps={{
                      sx: {
                        display: "table-header-group",
                        backgroundColor: "rgb(0,0,0)",
                        color: "white",
                      },
                    }}
                    initialState={{ expanded: false }}
                    muiTableContainerProps={{
                      sx: {
                        width: "100%",
                        overflowX: "auto",
                        backgroundColor: "#15aff4",
                        color: "white",
                      },
                    }}
                />
              </Box>
            </CardContent>
          </Card>

          {/* Another floating button (bottom‐right) with arrow up, if desired */}
          <Box sx={{ position: "absolute", bottom: 16, right: 16 }}>
            <Fab color="info" size="medium">
              <ArrowUpwardIcon />
            </Fab>
          </Box>

          {/* Dialog for creating a new device */}
          <Dialog   PaperProps={{
            sx: {
              backgroundColor: cardBgColor,
              color: textColor, // so text inherits this color by default
            },
          }} open={devicesDialogOpen} onClose={() => setDevicesDialogOpen(false)}>
            <DialogTitle sx={{ color: textColor }}>Add / Edit Device</DialogTitle>
            <DialogContent>
              <TextField
                  label="Serial Number"
                  fullWidth
                  variant="outlined"
                  sx={{
                    "& .MuiInputBase-input": {
                      color: textColor,
                      mb: 2
                    },
                  }}
                  margin="dense"
                  InputLabelProps={{
                    shrink: true,
                    sx: { color: textColor },
                  }}
                  value={deviceSerial}
                  onChange={(e) => setDeviceSerial(e.target.value)}
              />
              <TextField
                  label="Model"
                  fullWidth
                  variant="outlined"
                  margin="dense"
                  sx={{
                    "& .MuiInputBase-input": {
                      color: textColor,
                      mb: 2
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                    sx: { color: textColor },
                  }}
                  value={deviceModel}
                  onChange={(e) => setDeviceModel(e.target.value)}
              />
              <TextField
                  label="Name"
                  fullWidth
                  variant="outlined"
                  margin="dense"
                  sx={{
                    "& .MuiInputBase-input": {
                      color: textColor,
                      mb: 2
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                    sx: { color: textColor },
                  }}
                  value={deviceName}
                  onChange={(e) => setDeviceName(e.target.value)}
              />
              <TextField
                  label="Address"
                  fullWidth
                  variant="outlined"
                  margin="dense"
                  sx={{
                    marginTop: "10px",
                    "& .MuiInputBase-input": {
                      color: textColor,
                      mb: 2
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                    sx: { color: textColor },
                  }}
                  value={deviceAddress}
                  onChange={(e) => setDeviceAddress(e.target.value)}
              />
              <TextField
                  label="Lanes"
                  type="number"
                  margin="dense"
                  fullWidth
                  sx={{
                    "& .MuiInputBase-input": {
                      color: textColor
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                    sx: { color: textColor },
                  }}
                  variant="outlined"
                  value={deviceLanes}
                  onChange={(e) => setDeviceLanes(e.target.value)}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleSaveDevice} color="primary">
                Save
              </Button>
              <Button                   sx={{backgroundColor: "red", color: "#fff" ,"&:hover": {
                  backgroundColor: "darkred", // Change to a darker red for a nice effect
                }}}
                                        onClick={() => setDevicesDialogOpen(false)} color="secondary">
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
    );
  };

  // Theme‐related colors
  const textColor = darkMode ? "#fff" : "#000";
  const cardBgColor = darkMode ? "#1e293b" : "#fff";

  // Place creation
  const handleAddPlace = () => {
    setOpenDialog(true);
  };
  const handleDialogClose = () => {
    setOpenDialog(false);
    setNewPlaceName("");
  };

  function findNestedSubPlace(place, targetId) {
    if (!place.subPlaces) return null;

    for (const sub of place.subPlaces) {
      if (sub.id === targetId) {
        return sub;
      }
      const found = findNestedSubPlace(sub, targetId);
      if (found) {
        return found;
      }
    }
    return null;
  }

  /**
   * Given a newly created sub-place (newPlaceData),
   * attach it to an *existing* child (currentPlaceId)
   * in the top-level parent's nested subPlaces.
   */
  async function addSubPlaceToTopLevelParent(currentPlaceId, newPlaceData) {
    // 1) Climb up the chain of parents until we reach the top-level place (parentId = null).
    //    Because each 'place' is stored separately in JSON Server, we need to do multiple fetches:
    let placeToCheck = currentPlaceId;
    let topLevelId = currentPlaceId;

    while (placeToCheck) {
      const res = await fetch(`http://localhost:3001/places/${placeToCheck}`);
      if (!res.ok) throw new Error(`Place not found: ${placeToCheck}`);
      const placeData = await res.json();

      if (!placeData.parentId) {
        // Found the top-level place (no more parents).
        topLevelId = placeData.id;
        break;
      } else {
        // Keep climbing upward
        placeToCheck = placeData.parentId;
      }
    }

    // 2) Now fetch the *top-level* place object, which presumably holds the entire nested structure
    const topRes = await fetch(`http://localhost:3001/places/${topLevelId}`);
    if (!topRes.ok) throw new Error(`Failed to fetch top-level place: ${topLevelId}`);
    const topLevelPlace = await topRes.json();

    // 3) Find the *child* (with ID = currentPlaceId) deep inside the top-level place
    const child = findNestedSubPlace(topLevelPlace, currentPlaceId);
    if (!child) {
      console.warn(`Could not find place ${currentPlaceId} in top-level parent's subPlaces`);
      return;
    }

    // 4) Update child.subPlaces by adding the new sub-place
    child.subPlaces = Array.isArray(child.subPlaces)
        ? [...child.subPlaces, newPlaceData]
        : [newPlaceData];

    // 5) PUT the *entire* updated top-level place back to JSON Server
    const putRes = await fetch(`http://localhost:3001/places/${topLevelId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(topLevelPlace)
    });
    if (!putRes.ok) {
      throw new Error(`Failed to update top-level place ${topLevelId}`);
    }
  }

  async function handleCreatePlace() {
    // 1) Prepare a new place object
    const newPlace = {
      name: newPlaceName,
      address: place.address,
      parentId: place.id,       // The place you're "under"
      organizationId: place.organizationId
    };

    // 2) POST newPlace to create it in JSON Server
    const newPlaceRes = await fetch("http://localhost:3001/places", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(newPlace),
    });
    if (!newPlaceRes.ok) {
      throw new Error("Failed to create sub place");
    }

    const newPlaceData = await newPlaceRes.json();

    // 3) If you are using the mock data approach and want to maintain the nested structure:
    if (isMock) {
      // 3a) Update the *current place* (the direct parent). This might be optional if you only
      //     want the top-level parent's data to remain consistent, but let's do it:
      const updatedParent = {
        ...place,
        subPlaces: place.subPlaces
            ? [...place.subPlaces, newPlaceData]
            : [newPlaceData]
      };

      await fetch(`http://localhost:3001/places/${place.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(updatedParent),
      });

      // 3b) If place has a higher-level parent, we also want to update the top-level structure.
      //     (This is the crucial step!)
      if (place.parentId) {
        // Instead of just fetching `place.parentId` and updating it,
        // we find the *top-level* parent that truly holds the big nested tree:
        await addSubPlaceToTopLevelParent(place.id, newPlaceData);
      }
    }

    // 4) Finally, refetch the place we just updated so your state is correct
    const response = await fetch(`http://localhost:3001/places/${place.id}`);
    if (!response.ok) {
      throw new Error("Failed to fetch updated place");
    }
    const data = await response.json();
    setPlace(isMock ? data : data.place);

    handleDialogClose();
  }

  // ------------------
  //  Main Tab Content
  // ------------------

  // 1) Places tab
  const renderPlacesTab =  () => {

    // const subPlacesRes = await fetch(`http://ec2-51-17-165-3.il-central-1.compute.amazonaws.com:8080/api/v1/places/?SearchTerm=parentId=${id}`);
    // const subPlacesData = await subPlacesRes.json();
    // setSubPlaces(subPlacesData.places.data);
    // console.log(subPlacesData.places.data);
    const columns = [
      {
        accessorKey: "name",
        header: "Name",
        Cell: ({ row }) => (
            <a
                href={`/places/${row.original.id}`}
                style={{
                  color: darkMode ? "#059be5" : "blue",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
            >
              {row.original.name}
            </a>
        ),
      },
      {
        accessorKey: "id",
        header: "ID",
      },
      {
        accessorKey: "address",
        header: "Address",
      },
      {
        accessorKey: "devices",
        header: "Devices",
      },
    ];


    return (
        <Card sx={{ mt: 2, backgroundColor: cardBgColor }}>
          <CardHeader
              titleTypographyProps={{
                sx: {
                  color: textColor,
                },
              }}
              title="Places"
              sx={{ color: textColor, borderBottom: "1px solid #ccc" }}
          />
          <CardContent>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
              <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddIcon />}
                  onClick={handleAddPlace}
              >
                Add Place
              </Button>
            </Box>

            <Box sx={{ height: 400, width: "100%" }}>
              <MaterialReactTable
                  data={place?.subPlaces || []}
                  columns={columns}
                  enableGlobalFilter
                  muiBottomToolbarProps={{
                    sx: {
                      backgroundColor: darkMode ? '#1e293b' : '#fff',
                      color: darkMode ? '#fff' : '#1e293b',
                      ".MuiFormLabel-root": { color: darkMode ? '#fff' : '#1e293b' },
                      ".MuiSelect-icon": { color: darkMode ? '#fff' : '#1e293b' },
                      ".MuiSelect-select": { color: darkMode ? '#fff' : '#1e293b' },
                      ".MuiBox-root.MuiButtonBase-root": { color: darkMode ? '#fff' : '#1e293b' },
                      ".MuiSvgIcon-root": { color: darkMode ? '#fff' : '#1e293b' },
                      '& .MuiButtonBase-root.Mui-disabled .MuiSvgIcon-root': {
                        color: darkMode ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
                      },
                    },
                  }}
                  muiTopToolbarProps={{
                    sx: {
                      backgroundColor: darkMode ? '#1e293b' : '#fff',
                      color: '#fff',
                      ".MuiSvgIcon-root": { color: darkMode ? '#fff' : '#1e293b' },
                      ".MuiTableSortLabel-iconDirectionAsc": { color: darkMode ? '#fff' : '#1e293b' },
                      '& .MuiInputBase-input': { color: darkMode ? '#fff' : '#1e293b' },
                    },
                  }}
                  muiTableBodyCellProps={{
                    sx: {
                      backgroundColor: darkMode ? "#1e293b" : "#ffffff",
                      color: darkMode ? "#ffffff" : "#000",
                      ".MuiSvgIcon-root": { color: darkMode ? "#ffffff" : "#000" },
                    },
                  }}
                  muiTableHeadCellProps={{
                    sx: {
                      backgroundColor: darkMode ? "#1e293b" : "#0098CF",
                      color: darkMode ? "#ffffff" : "#000",
                      fontWeight: "bold",
                      ".MuiSvgIcon-root": { color: darkMode ? "#ffffff" : "#000" },
                      '& .MuiTableSortLabel-icon': {
                        color: darkMode ? '#fff !important' : '#000 !important',
                      },
                      '& .MuiTableSortLabel-iconDirectionAsc': {
                        color: darkMode ? '#fff !important' : '#000 !important',
                      },
                      '& .MuiTableSortLabel-iconDirectionDesc': {
                        color: darkMode ? '#fff !important' : '#000 !important',
                      },
                      '& .MuiButtonBase-root.Mui-disabled .MuiSvgIcon-root': {
                        color: darkMode ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
                      },
                      '& .MuiInputBase-input': {
                        color: darkMode ? '#fff' : '#1e293b',
                      },
                    },
                  }}
                  globalFilterFn="recursiveSearch"
                  filterFns={{
                    recursiveSearch: (row, columnId, filterValue) =>
                        searchRowRecursively(row, columnId, filterValue),
                  }}
                  muiTableHeadProps={{
                    sx: {
                      display: "table-header-group",
                      backgroundColor: "rgb(0,0,0)",
                      color: "white",
                    },
                  }}
                  initialState={{ expanded: false }}
                  muiTableContainerProps={{
                    sx: {
                      width: "100%",
                      overflowX: "auto",
                      backgroundColor: "#15aff4",
                      color: "white",
                    },
                  }}
              />
            </Box>
          </CardContent>

          {/* Add new place dialog */}
          <Dialog open={openDialog} onClose={handleDialogClose}>
            <DialogTitle sx={{ color: "#000" }}>Create new place</DialogTitle>
            <DialogContent>
              <TextField
                  autoFocus
                  margin="dense"
                  label="Name"
                  type="text"
                  fullWidth
                  sx={{
                    "& .MuiInputBase-input": {
                      color: textColor,
                      mb: 2
                    },
                  }}
                  variant="outlined"
                  value={newPlaceName}
                  onChange={(e) => setNewPlaceName(e.target.value)}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCreatePlace} color="primary">
                Create
              </Button>
              <Button                   sx={{backgroundColor: "red", color: "#fff", "&:hover": {
                  backgroundColor: "darkred", // Change to a darker red for a nice effect
                }}}
                                        onClick={handleDialogClose} color="secondary">
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
        </Card>
    );
  };

  // 2) General tab
  const renderGeneralTab = () => (
      <Box sx={{ padding: "20px", display: selectedTab === 0 ? "block" : "none" }}>
        <Typography variant="h4" gutterBottom sx={{ color: darkMode ? "#fff" : textColor, mb: 2 }}>
          Place Details
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={4}>
            <Card sx={{ backgroundColor: cardBgColor }}>
              <CardContent>
                <Typography variant="h6" sx={{ color: textColor, mb: 1 }}>
                  <LocationOnIcon sx={{ mr: 1 }} />
                  Name
                </Typography>
                <Typography sx={{ color: textColor }}>{place.name}</Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Card sx={{ backgroundColor: cardBgColor }}>
              <CardContent>
                <Typography variant="h6" sx={{ color: textColor, mb: 1 }}>
                  <PlaceIcon sx={{ mr: 1 }} />
                  Address
                </Typography>
                <Typography sx={{ color: textColor }}>{place.address}</Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Card sx={{ backgroundColor: cardBgColor }}>
              <CardContent>
                <Typography variant="h6" sx={{ color: textColor, mb: 1 }}>
                  <PersonIcon sx={{ mr: 1 }} />
                  Users
                </Typography>
                <Typography sx={{ color: textColor }}>{users.length}</Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Card sx={{ backgroundColor: cardBgColor }}>
              <CardContent>
                <Typography variant="h6" sx={{ color: textColor, mb: 1 }}>
                  <DevicesIcon sx={{ mr: 1 }} />
                  Devices
                </Typography>
                <Typography sx={{ color: textColor }}>{place?.devices?.length || '-'}</Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Card sx={{ backgroundColor: cardBgColor }}>
              <CardContent>
                <Typography variant="h6" sx={{ color: textColor, mb: 1 }}>
                  <PlaceIcon sx={{ mr: 1 }} />
                  Places
                </Typography>
                <Typography sx={{ color: textColor }}>{place?.subPlaces?.length}</Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Box
            ref={mapContainerRef}
            sx={{
              width: "100%",
              height: "400px",
              mt: 3,
              borderRadius: 2,
              overflow: "hidden",
            }}
        />
      </Box>
  );

  // 3) Users tab
  const renderUsersTab = () => {
    const columns = [
      {
        accessorKey: "name",
        header: "Name",
        // Combines firstName and lastName into a single cell
        Cell: ({ row }) => `${row.original.firstName} ${row.original.lastName}`,
      },
      {
        accessorKey: "phoneNumber",
        header: "Phone Number",
        Cell: ({ row }) => (
            <a
                href={`tel:${row.original.phoneNumber}`}
                style={{ color: "inherit", textDecoration: "none" }}
            >
              {row.original.phoneNumber}
            </a>
        ),
      },
      {
        accessorKey: "carsLimit",
        header: "Car Limit",
      },
      {
        accessorKey: "cars",
        header: "Cars",
        // Shows a clickable number; when clicked => open a dialog with license plates
        Cell: ({ row }) => {
          const handleClick = () => {
            setSelectedUser(row.original);
            setShowCarsDialogOpen(true);
          };
          const numCars = row.original.cars?.length || 0;
          return (
              <span
                  onClick={handleClick}
                  style={{
                    color: "#1976d2",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
              >
          {numCars === 1 ? "1 Car" : `${numCars} Cars`}
        </span>
          );
        },
      },
    ];


    const handleOpenAddUser = () => {
      // Reset the newUser object if desired
      setNewUser({
        placeId: id,
        phoneNumber: "",
        firstName: "",
        lastName: "",
        carsLimit: 10,
        notes: "",
        cars: [],
        idNumber: "999999999"
      });
      setAddUserDialogOpen(true);
    };

    // Handler for saving the newly created user
    const handleSaveNewUser = async () => {
      // Here you’d typically POST to your backend
      // For demo, just log or push to local “rows”
      console.log("New user data:", newUser);


      const addedUserRes = await fetch('http://localhost:3001/parkingUser',

          {
            method: 'POST',
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(newUser),
          })
      const addedUser = await addedUserRes.json();
      setUsers([...users, addedUser]);
      // If you maintain your own “users” array in state,
      // you can do something like:
      // setUsers([...users, newUser]);

      setAddUserDialogOpen(false);
    };

    // Handler for opening the Add Car mini-dialog
    const handleOpenAddCar = () => {
      // Reset car fields
      setNewCar({
        licensePlate: "",
        color: "",
        brand: "",
        model: "",
      });
      setAddCarDialogOpen(true);
    };

    // Handler for saving the newly added car
    const handleSaveCar = () => {
      if (!newCar.licensePlate.trim()) {
        alert("Car ID is required");
        return;
      }
      // Add this car into newUser.cars
      setNewUser({
        ...newUser,
        cars: [...newUser.cars, newCar],
      });
      setAddCarDialogOpen(false);
    };

    // Handler for deleting a car from the newUser’s car list
    const handleDeleteCar = (carId) => {
      setNewUser({
        ...newUser,
        cars: newUser.cars.filter((c) => c.id !== carId),
      });
    };


    return (
        <Card sx={{ mt: 2, backgroundColor: cardBgColor }}>
          <CardHeader
              titleTypographyProps={{
                sx: {
                  color: textColor,
                },
              }}
              sx={{ color: textColor, borderBottom: "1px solid #ccc" }}
              title="Users List"
          />
          <CardContent>
            <Typography variant="body1" sx={{ color: textColor, mb: 2, fontWeight: 500 }}>
              Cars present: 231 | Count: 188
            </Typography>
            <Box sx={{ mb: 2, display: "flex", justifyContent: "flex-end" }}>
              <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={handleOpenAddUser}>
                Add User
              </Button>
            </Box>
            <Box sx={{ height: 400, width: "100%" }}>
              <MaterialReactTable
                  data={users}
                  columns={columns}
                  enableGlobalFilter
                  muiBottomToolbarProps={{
                    sx: {
                      backgroundColor: darkMode ? '#1e293b' : '#fff',
                      color: darkMode ? '#fff' : '#1e293b',
                      ".MuiFormLabel-root": { color: darkMode ? '#fff' : '#1e293b' },
                      ".MuiSelect-icon": { color: darkMode ? '#fff' : '#1e293b' },
                      ".MuiSelect-select": { color: darkMode ? '#fff' : '#1e293b' },
                      ".MuiBox-root.MuiButtonBase-root": { color: darkMode ? '#fff' : '#1e293b' },
                      ".MuiSvgIcon-root": { color: darkMode ? '#fff' : '#1e293b' },
                      '& .MuiButtonBase-root.Mui-disabled .MuiSvgIcon-root': {
                        color: darkMode ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
                      },
                    },
                  }}
                  muiTopToolbarProps={{
                    sx: {
                      backgroundColor: darkMode ? '#1e293b' : '#fff',
                      color: '#fff',
                      ".MuiSvgIcon-root": { color: darkMode ? '#fff' : '#1e293b' },
                      ".MuiTableSortLabel-iconDirectionAsc": { color: darkMode ? '#fff' : '#1e293b' },
                      '& .MuiInputBase-input': { color: darkMode ? '#fff' : '#1e293b' },
                    },
                  }}
                  muiTableBodyCellProps={{
                    sx: {
                      backgroundColor: darkMode ? "#1e293b" : "#ffffff",
                      color: darkMode ? "#ffffff" : "#000",
                      ".MuiSvgIcon-root": { color: darkMode ? "#ffffff" : "#000" },
                    },
                  }}
                  muiTableHeadCellProps={{
                    sx: {
                      backgroundColor: darkMode ? "#1e293b" : "#0098CF",
                      color: darkMode ? "#ffffff" : "#000",
                      fontWeight: "bold",
                      ".MuiSvgIcon-root": { color: darkMode ? "#ffffff" : "#000" },
                      '& .MuiTableSortLabel-icon': {
                        color: darkMode ? '#fff !important' : '#000 !important',
                      },
                      '& .MuiTableSortLabel-iconDirectionAsc': {
                        color: darkMode ? '#fff !important' : '#000 !important',
                      },
                      '& .MuiTableSortLabel-iconDirectionDesc': {
                        color: darkMode ? '#fff !important' : '#000 !important',
                      },
                      '& .MuiButtonBase-root.Mui-disabled .MuiSvgIcon-root': {
                        color: darkMode ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
                      },
                      '& .MuiInputBase-input': {
                        color: darkMode ? '#fff' : '#1e293b',
                      },
                    },
                  }}
                  globalFilterFn="recursiveSearch"
                  filterFns={{
                    recursiveSearch: (row, columnId, filterValue) =>
                        searchRowRecursively(row, columnId, filterValue),
                  }}
                  muiTableHeadProps={{
                    sx: {
                      display: "table-header-group",
                      backgroundColor: "rgb(0,0,0)",
                      color: "white",
                    },
                  }}
                  initialState={{ expanded: false }}
                  muiTableContainerProps={{
                    sx: {
                      width: "100%",
                      overflowX: "auto",
                      backgroundColor: "#15aff4",
                      color: "white",
                    },
                  }}
              />
            </Box>
          </CardContent>
          <Dialog open={addUserDialogOpen} onClose={() => setAddUserDialogOpen(false)} fullWidth maxWidth="sm">
            <DialogTitle sx={{ color: "#000" }}>Add User</DialogTitle>
            <DialogContent>

              {/* Phone Code & Number */}
              <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
                <TextField
                    label="Phone Number"
                    fullWidth
                    variant="outlined"
                    sx={{
                      "& .MuiInputBase-input": {
                        color: "#000",
                        mb: 2
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                      sx: { color: "#000", "&.MuiInputLabel-shrink": {lineHeight: 2.5}},

                    }}
                    value={newUser.phoneNumber}
                    onChange={(e) => setNewUser({ ...newUser, phoneNumber: e.target.value })}
                />
              </Box>

              {/* First & Last name */}
              <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
                <TextField
                    label="First Name"
                    fullWidth
                    variant="outlined"
                    sx={{
                      "& .MuiInputBase-input": {
                        color: "#000",
                        mb: 2
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                      sx: { color: "#000",
                      },
                    }}
                    value={newUser.firstName}
                    onChange={(e) => setNewUser({ ...newUser, firstName: e.target.value })}
                />
                <TextField
                    label="Last Name"
                    fullWidth
                    variant="outlined"
                    sx={{
                      "& .MuiInputBase-input": {
                        color:                         "#000"
                      ,
                        mb: 2
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                      sx: { color: "#000" },
                    }}
                    value={newUser.lastName}
                    onChange={(e) => setNewUser({ ...newUser, lastName: e.target.value })}
                />
              </Box>

              {/* Car limit */}
              <TextField
                  label="Cars limit"
                  type="number"
                  fullWidth
                  sx={{
                    "& .MuiInputBase-input": {
                      color: "#000",
                      mb: 2
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                    sx: { color: "#000" },
                  }}
                  variant="outlined"
                  // sx={{ mb: 2 }}
                  value={newUser.carsLimit}
                  onChange={(e) => setNewUser({ ...newUser, carsLimit: Number(e.target.value) })}
              />

              {/* Notes */}
              <TextField
                  label="Notes"
                  multiline
                  rows={2}
                  fullWidth
                  variant="outlined"
                  sx={{
                    marginTop: "10px",
                    "& .MuiInputBase-input": {
                      color: "#000",
                      mb: 2
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                    sx: { color: "#000" },
                  }}
                  value={newUser.notes}
                  onChange={(e) => setNewUser({ ...newUser, notes: e.target.value })}
              />

              {/* Cars sub-section */}
              <Typography variant="h6" sx={{ mb: 1 }}>
                Cars
              </Typography>
              <Button
                  variant="contained"
                  size="small"
                  startIcon={<AddIcon />}
                  onClick={handleOpenAddCar}
                  sx={{ mb: 2 }}
              >
                Add Car
              </Button>

              {/* Table of cars */}
              {newUser.cars.length > 0 && (
                  <Box sx={{ maxHeight: 200, overflowY: "auto" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <thead style={{ backgroundColor: cardBgColor }}>
                      <tr>
                        <th style={{ padding: "8px", textAlign: "left" }}>Car id</th>
                        <th style={{ padding: "8px", textAlign: "left" }}>Color</th>
                        <th style={{ padding: "8px", textAlign: "left" }}>Brand</th>
                        <th style={{ padding: "8px", textAlign: "left" }}>Model</th>
                        <th style={{ padding: "8px" }}>Delete</th>
                      </tr>
                      </thead>
                      <tbody>
                      {newUser.cars.map((car) => (
                          <tr key={car.id}>
                            <td style={{ padding: "8px", color: textColor }}>{car.licensePlate}</td>
                            <td style={{ padding: "8px", color: textColor }}>{car.color}</td>
                            <td style={{ padding: "8px", color: textColor }}>{car.brand}</td>
                            <td style={{ padding: "8px", color: textColor }}>{car.model}</td>
                            <td style={{ padding: "8px", color: textColor, textAlign: "center" }}>
                              <IconButton
                                  onClick={() => handleDeleteCar(car.id)}
                                  color="error"
                                  size="small"
                              >
                                <DeleteIcon />
                              </IconButton>
                            </td>
                          </tr>
                      ))}
                      </tbody>
                    </table>
                  </Box>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={handleSaveNewUser} variant="contained" color="primary">
                Save
              </Button>
              <Button                   sx={{backgroundColor: "red", color: "#fff", "&:hover": {
                  backgroundColor: "darkred", // Change to a darker red for a nice effect
                }}}
                                        onClick={() => setAddUserDialogOpen(false)} variant="outlined" color="secondary">
                Cancel
              </Button>
            </DialogActions>
          </Dialog>

          {/* --- DIALOG 2: ADD CAR --- */}
          <Dialog open={addCarDialogOpen} onClose={() => setAddCarDialogOpen(false)} fullWidth maxWidth="xs">
            <DialogTitle sx={{ color: "#000" }}>Add Car</DialogTitle>
            <DialogContent>
              <TextField
                  label="Id *"
                  fullWidth
                  variant="outlined"
                  sx={{
                    marginTop: "10px",
                    "& .MuiInputBase-input": {
                      color: "#000",
                      mb: 2
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                    sx: { color: "#000" },
                  }}
                  value={newCar.licensePlate}
                  onChange={(e) => setNewCar({ ...newCar, licensePlate: e.target.value })}
              />
              <TextField
                  label="Color"
                  fullWidth
                  variant="outlined"
                  sx={{
                    marginTop: "10px",
                    "& .MuiInputBase-input": {
                      color: "#000",
                      mb: 2
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                    sx: { color: "#000" },
                  }}
                  value={newCar.color}
                  onChange={(e) => setNewCar({ ...newCar, color: e.target.value })}
              />
              <TextField
                  label="Brand"
                  fullWidth
                  variant="outlined"
                  sx={{
                    marginTop: "10px",
                    "& .MuiInputBase-input": {
                      color: "#000",
                      mb: 2
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                    sx: { color: "#000" },
                  }}
                  value={newCar.brand}
                  onChange={(e) => setNewCar({ ...newCar, brand: e.target.value })}
              />
              <TextField
                  label="Model"
                  fullWidth
                  variant="outlined"
                  sx={{
                    marginTop: "10px",
                    "& .MuiInputBase-input": {
                      color: "#000",
                      mb: 2
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                    sx: { color: "#000" },
                  }}
                  value={newCar.model}
                  onChange={(e) => setNewCar({ ...newCar, model: e.target.value })}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleSaveCar} variant="contained" color="primary">
                Finish
              </Button>
              <Button                   sx={{backgroundColor: "red", color: "#fff", "&:hover": {
                  backgroundColor: "darkred", // Change to a darker red for a nice effect
                }}}
                                        onClick={() => setAddCarDialogOpen(false)} variant="outlined" color="secondary">
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
              open={showCarsDialogOpen}
              onClose={() => setShowCarsDialogOpen(false)}
              fullWidth
              maxWidth="xs"
          >
            <DialogTitle sx={{color: "#000"}}>Car License Plates</DialogTitle>
            <DialogContent sx={{color: "#000"}}>
              {selectedUser && selectedUser.cars && selectedUser.cars.length > 0 ? (
                  selectedUser.cars.map((car, index) => (
                      <Typography key={index} sx={{ mb: 1 }}>
                        {car.licensePlate}
                      </Typography>
                  ))
              ) : (
                  <Typography>No cars found.</Typography>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setShowCarsDialogOpen(false)} color="primary">
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </Card>
    );
  };

  // 4) Log tab
  function renderLogTab() {
    // Define columns based on the socket data structure
    // (Feel free to rename headers or add more fields as desired)
    const columns = [
      {
        accessorKey: "uid",
        header: "User ID",
        filterFn: (row, columnId, filterValue) =>
            searchRowRecursively(row, columnId, filterValue),
      },
      {
        accessorKey: "carId",
        header: "Car ID",
        filterFn: (row, columnId, filterValue) =>
            searchRowRecursively(row, columnId, filterValue),
      },
      {
        accessorKey: "direction",
        header: "Direction",
        filterFn: (row, columnId, filterValue) =>
            searchRowRecursively(row, columnId, filterValue),
      },
      {
        accessorKey: "approved",
        header: "Approved?",
        Cell: ({ cell }) => (cell.getValue() ? "Yes" : "No"),
        filterFn: (row, columnId, filterValue) =>
            searchRowRecursively(row, columnId, filterValue),
      },
      {
        accessorKey: "guest",
        header: "Guest?",
        Cell: ({ cell }) => (cell.getValue() ? "Yes" : "No"),
        filterFn: (row, columnId, filterValue) =>
            searchRowRecursively(row, columnId, filterValue),
      },
      {
        accessorKey: "tm",
        header: "Timestamp",
        Cell: ({ cell }) => {
          const unixSecs = cell.getValue();
          return new Date(unixSecs * 1000).toLocaleString();
        },
        filterFn: (row, columnId, filterValue) =>
            searchRowRecursively(row, columnId, filterValue),
      },
      {
        accessorKey: "reason",
        header: "Reason",
        filterFn: (row, columnId, filterValue) =>
            searchRowRecursively(row, columnId, filterValue),
      },
    ];
    const searchRowRecursively = (row, columnId, filterValue) => {
      const value = row.getValue(columnId);
      if (value?.toLowerCase().includes(filterValue.toLowerCase())) {
        return true;
      }
      if (row.subPlaces?.length) {
        return row.subPlaces.some((subRow) => searchRowRecursively(subRow, columnId, filterValue));
      }
      return false;
    };
    return (
        <Card sx={{ mt: 2, backgroundColor: cardBgColor }}>
          <CardHeader
              titleTypographyProps={{ sx: { color: textColor } }}
              title="Log Entries"
              sx={{ color: textColor, borderBottom: "1px solid #ccc" }}
          />
          <CardContent>
            <Box sx={{ height: 400, width: "100%" }}>
              <MaterialReactTable
                  data={socketLog}
                  columns={columns}
                  enableGlobalFilter
                  muiBottomToolbarProps={{
                    sx: {
                      backgroundColor: darkMode ? '#1e293b' : '#fff',
                      color: darkMode ? '#fff' : '#1e293b',
                      ".MuiFormLabel-root": { color: darkMode ? '#fff' : '#1e293b' },
                      ".MuiSelect-icon": { color: darkMode ? '#fff' : '#1e293b' },
                      ".MuiSelect-select": { color: darkMode ? '#fff' : '#1e293b' },
                      ".MuiBox-root.MuiButtonBase-root": { color: darkMode ? '#fff' : '#1e293b' },
                      ".MuiSvgIcon-root": { color: darkMode ? '#fff' : '#1e293b' },
                      '& .MuiButtonBase-root.Mui-disabled .MuiSvgIcon-root': {
                        color: darkMode ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
                      },
                    },
                  }}
                  muiTopToolbarProps={{
                    sx: {
                      backgroundColor: darkMode ? '#1e293b' : '#fff',
                      color: '#fff',
                      ".MuiSvgIcon-root": { color: darkMode ? '#fff' : '#1e293b' },
                      ".MuiTableSortLabel-iconDirectionAsc": { color: darkMode ? '#fff' : '#1e293b' },
                      '& .MuiInputBase-input': { color: darkMode ? '#fff' : '#1e293b' },
                    },
                  }}
                  muiTableBodyCellProps={{
                    sx: {
                      backgroundColor: darkMode ? "#1e293b" : "#ffffff",
                      color: darkMode ? "#ffffff" : "#000",
                      ".MuiSvgIcon-root": { color: darkMode ? "#ffffff" : "#000" },
                    },
                  }}
                  muiTableHeadCellProps={{
                    sx: {
                      backgroundColor: darkMode ? "#1e293b" : "#0098CF",
                      color: darkMode ? "#ffffff" : "#000",
                      fontWeight: "bold",
                      ".MuiSvgIcon-root": { color: darkMode ? "#ffffff" : "#000" },
                      '& .MuiTableSortLabel-icon': {
                        color: darkMode ? '#fff !important' : '#000 !important',
                      },
                      '& .MuiTableSortLabel-iconDirectionAsc': {
                        color: darkMode ? '#fff !important' : '#000 !important',
                      },
                      '& .MuiTableSortLabel-iconDirectionDesc': {
                        color: darkMode ? '#fff !important' : '#000 !important',
                      },
                      '& .MuiButtonBase-root.Mui-disabled .MuiSvgIcon-root': {
                        color: darkMode ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
                      },
                      '& .MuiInputBase-input': {
                        color: darkMode ? '#fff' : '#1e293b',
                      },
                    },
                  }}
                  globalFilterFn="recursiveSearch"
                  filterFns={{
                    recursiveSearch: (row, columnId, filterValue) =>
                        searchRowRecursively(row, columnId, filterValue),
                  }}
                  muiTableHeadProps={{
                    sx: {
                      display: "table-header-group",
                      backgroundColor: "rgb(0,0,0)",
                      color: "white",
                    },
                  }}
                  initialState={{ expanded: false }}
                  muiTableContainerProps={{
                    sx: {
                      width: "100%",
                      overflowX: "auto",
                      backgroundColor: "#15aff4",
                      color: "white",
                    },
                  }}
              />
            </Box>
          </CardContent>
        </Card>
    );
  }

  // ------------------------
  // SETTINGS Sub‐Tabs
  // ------------------------

  // (1) General sub‐tab
  function renderSettingsGeneral() {
    return (
        <Box sx={{ p: 2 }}>
          <Typography variant="h6" sx={{ mb: 2, color: textColor }}>
            General Settings
          </Typography>
          <Grid container spacing={2} sx={{ mb: 2 }}>
            {/* Type */}
            {/*<Grid item xs={12} sm={4}>*/}
            {/*  <FormControl fullWidth variant="outlined">*/}
            {/*    <InputLabel sx={{ color: textColor }} id="type-label">*/}
            {/*      Type*/}
            {/*    </InputLabel>*/}
            {/*    <Select*/}
            {/*        labelId="type-label"*/}
            {/*        id="type-select"*/}
            {/*        value={typeValue}*/}
            {/*        onChange={(e) => setTypeValue(e.target.value)}*/}
            {/*        label="Type"*/}
            {/*        sx={{*/}
            {/*          height: "45px",*/}
            {/*          color: textColor,*/}
            {/*          "& .MuiSelect-select": {*/}
            {/*            color: textColor,*/}
            {/*          },*/}
            {/*          "& .MuiOutlinedInput-notchedOutline": {*/}
            {/*            borderColor: textColor,*/}
            {/*          },*/}
            {/*          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {*/}
            {/*            borderColor: "#1976d2",*/}
            {/*          },*/}
            {/*          "& .MuiSelect-icon": {*/}
            {/*            color: textColor,*/}
            {/*          },*/}
            {/*        }}*/}
            {/*    >*/}
            {/*      <MenuItem value="LPR PARK PAYMENT">LPR PARK PAYMENT</MenuItem>*/}
            {/*      <MenuItem value="LPR PARK">LPR PARK</MenuItem>*/}
            {/*      <MenuItem value="GENERAL">GENERAL</MenuItem>*/}
            {/*    </Select>*/}
            {/*  </FormControl>*/}
            {/*</Grid>*/}

            {/* Parking Allocation */}
            <Grid item xs={12} sm={4}>
              <TextField
                  label="Parking Allocation"
                  type="number"
                  variant="outlined"
                  value={parkingSettings?.parkingAllocation}
                  onChange={(e)=>setParkingSettings({...parkingSettings, parkingAllocation: parseInt(e.target.value)})}
                  fullWidth
                  sx={{
                    "& .MuiInputBase-input": {
                      color: textColor,
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                    sx: { color: textColor },
                  }}
              />
            </Grid>

            {/* Overflow Count */}
            <Grid item xs={12} sm={4}>
              <TextField
                  label="Overflow Count"
                  type="number"
                  variant="outlined"
                  fullWidth
                  value={parkingSettings?.overflowCount}
                  onChange={(e)=>setParkingSettings({...parkingSettings, overflowCount: parseInt(e.target.value)})}
                  sx={{
                    "& .MuiInputBase-input": {
                      color: textColor,
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                    sx: { color: textColor },
                  }}
              />
            </Grid>
          </Grid>

          {/* Free time */}
          {/*authorizeAllStayTime in pal in the place response*/}
          <Box sx={{ display: "flex", alignItems: "center", mb: 2, flexWrap: "wrap" }}>
            <Typography sx={{ mr: 2, color: textColor }}>Free time</Typography>
            <TextField
                type="number"
                defaultValue={ Math.floor((place?.settings?.freeTime || 0)/60)  }
                onChange={(e)=> setFreeTimeHours(parseInt(e.target.value))}
                sx={{
                  width: 70,
                  mr: 1,
                  "& .MuiInputBase-input": {
                    color: textColor,
                  },
                }}
            />
            :
            <TextField
                type="number"
                defaultValue={(place?.settings?.freeTime || 0) % 60}
                onChange={(e)=> setFreeTimeMinutes(parseInt(e.target.value))}
                sx={{
                  width: 70,
                  mx: 1,
                  "& .MuiInputBase-input": {
                    color: textColor,
                  },
                }}
            />
          </Box>

          {/* Checkboxes */}
          {/*<Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>*/}
          {/*  <FormControlLabel*/}
          {/*      control={<Checkbox color="secondary" defaultChecked />}*/}
          {/*      label="Top place"*/}
          {/*      sx={{ mr: 3, color: textColor }}*/}
          {/*      disableTypography*/}
          {/*  />*/}
          {/*  <FormControlLabel*/}
          {/*      control={<Checkbox color="secondary" defaultChecked />}*/}
          {/*      label="Control tab"*/}
          {/*      sx={{ color: textColor }}*/}
          {/*      disableTypography*/}
          {/*  />*/}
          {/*</Box>*/}

          {/* Clear cars present button */}
          <Button
              variant="contained"
              color="error"
              sx={{ mr: 2, backgroundColor: "red", "&:hover": {
                  backgroundColor: "darkred", // Change to a darker red for a nice effect
                },
              }}
          >
            Clear cars present
          </Button>
          {/* Save button */}
          <Button onClick={handleSaveSettings} variant="contained" color="primary" sx={{ float: "right" }}>
            Save
          </Button>
        </Box>
    );
  }

  // (2) **Organizations** sub‐tab (UPDATED to match your screenshot)
  const renderSettingsOrganizations = () => {
    // Columns for the DataGrid
    const orgColumns = [
      {
        accessorKey: "name",
        header: "Name",
      },
      {
        accessorKey: "address",
        header: "Address",
      },
      {
        accessorKey: "id",
        header: "ID",
      },
      {
        accessorKey: "actions",
        header: "",
        Cell: ({ row }) => (
            <Box sx={{ display: "flex", gap: 1 }}>
              {/* Edit button */}
              <IconButton
                  sx={{ backgroundColor: "#1976d2", color: "#fff" }}
                  size="small"
                  onClick={() => handleEditOrg(row.original)}
              >
                <EditIcon fontSize="small" />
              </IconButton>
              {/* Delete button (uncomment if needed)
        <IconButton
          sx={{ backgroundColor: "red", color: "#fff" }}
          size="small"
          onClick={() => handleDeleteOrg(row.original.id)}
        >
          <DeleteIcon fontSize="small" />
        </IconButton> */}
            </Box>
        ),
        enableSorting: false,
      },
    ];

    return (
        <Box sx={{ p: 2, position: "relative" }}>
          {/* Title and Count */}
          {/* The table of organizations */}
          <Card sx={{ mt: 2, backgroundColor: cardBgColor }}>
            <CardContent>
              <IconButton
                  sx={{ backgroundColor: "#1976d2", color: "#fff" }}
                  size="small"
                  onClick={() => handleEditOrg()}
              >
                <AddIcon fontSize="small" />
              </IconButton>
              <Box sx={{ height: 360, width: "100%" }}>
                <MaterialReactTable
                    data={organization}
                    columns={orgColumns}
                    enableGlobalFilter
                    muiBottomToolbarProps={{
                      sx: {
                        backgroundColor: darkMode ? '#1e293b' : '#fff',
                        color: darkMode ? '#fff' : '#1e293b',
                        ".MuiFormLabel-root": { color: darkMode ? '#fff' : '#1e293b' },
                        ".MuiSelect-icon": { color: darkMode ? '#fff' : '#1e293b' },
                        ".MuiSelect-select": { color: darkMode ? '#fff' : '#1e293b' },
                        ".MuiBox-root.MuiButtonBase-root": { color: darkMode ? '#fff' : '#1e293b' },
                        ".MuiSvgIcon-root": { color: darkMode ? '#fff' : '#1e293b' },
                        '& .MuiButtonBase-root.Mui-disabled .MuiSvgIcon-root': {
                          color: darkMode ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
                        },
                      },
                    }}
                    muiTopToolbarProps={{
                      sx: {
                        backgroundColor: darkMode ? '#1e293b' : '#fff',
                        color: '#fff',
                        ".MuiSvgIcon-root": { color: darkMode ? '#fff' : '#1e293b' },
                        ".MuiTableSortLabel-iconDirectionAsc": { color: darkMode ? '#fff' : '#1e293b' },
                        '& .MuiInputBase-input': { color: darkMode ? '#fff' : '#1e293b' },
                      },
                    }}
                    muiTableBodyCellProps={{
                      sx: {
                        backgroundColor: darkMode ? "#1e293b" : "#ffffff",
                        color: darkMode ? "#ffffff" : "#000",
                        ".MuiSvgIcon-root": { color: darkMode ? "#ffffff" : "#000" },
                      },
                    }}
                    muiTableHeadCellProps={{
                      sx: {
                        backgroundColor: darkMode ? "#1e293b" : "#0098CF",
                        color: darkMode ? "#ffffff" : "#000",
                        fontWeight: "bold",
                        ".MuiSvgIcon-root": { color: darkMode ? "#ffffff" : "#000" },
                        '& .MuiTableSortLabel-icon': {
                          color: darkMode ? '#fff !important' : '#000 !important',
                        },
                        '& .MuiTableSortLabel-iconDirectionAsc': {
                          color: darkMode ? '#fff !important' : '#000 !important',
                        },
                        '& .MuiTableSortLabel-iconDirectionDesc': {
                          color: darkMode ? '#fff !important' : '#000 !important',
                        },
                        '& .MuiButtonBase-root.Mui-disabled .MuiSvgIcon-root': {
                          color: darkMode ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
                        },
                        '& .MuiInputBase-input': {
                          color: darkMode ? '#fff' : '#1e293b',
                        },
                      },
                    }}
                    globalFilterFn="recursiveSearch"
                    filterFns={{
                      recursiveSearch: (row, columnId, filterValue) =>
                          searchRowRecursively(row, columnId, filterValue),
                    }}
                    muiTableHeadProps={{
                      sx: {
                        display: "table-header-group",
                        backgroundColor: "rgb(0,0,0)",
                        color: "white",
                      },
                    }}
                    initialState={{ expanded: false }}
                    muiTableContainerProps={{
                      sx: {
                        width: "100%",
                        overflowX: "auto",
                        backgroundColor: "#15aff4",
                        color: "white",
                      },
                    }}
                />
              </Box>
            </CardContent>
          </Card>

          {/* Dialog for adding/editing an organization */}
          <Dialog   PaperProps={{
            sx: {
              backgroundColor: cardBgColor,
              color: textColor, // so text inherits this color by default
            },
          }} open={orgDialogOpen} onClose={() => setOrgDialogOpen(false)}>
            <DialogTitle sx={{ color: textColor, backgroundColor: cardBgColor }}>Add / Edit Organization</DialogTitle>
            <DialogContent sx={{backgroundColor: cardBgColor}}>
              <Select
                  value={orgOption}
                  onChange={(e) => setOrgOption(e.target.value)}
                  label="Operation"
                  sx={{
                    marginTop: "10px",
                    height: "45px",
                    color: textColor,
                    "& .MuiSelect-select": {
                      color: textColor,
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: textColor,
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#1976d2",
                    },
                    "& .MuiSelect-icon": {
                      color: textColor,
                    },
                  }}
                  margin="dense"
              >
                {allOrgs.map(org => <MenuItem value={org.id}>{org.name}</MenuItem>)}
              </Select>
            </DialogContent>
            <DialogActions sx={{backgroundColor: cardBgColor}}>
              <Button onClick={handleSaveOrg} color="primary">
                Save
              </Button>
              <Button                   sx={{backgroundColor: "red", color: "#fff", "&:hover": {
                  backgroundColor: "darkred", // Change to a darker red for a nice effect
                }}}
                                        onClick={() => setOrgDialogOpen(false)} color="secondary">
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
    );
  };
  const handleAddTariffClick = () => {
    setTariffName("");
    setTariffId("");
    setTariffStart("00:00:00");
    setTariffEnd("00:00:00");
    setTariffDays(["Mo", "Tu", "We"]);
    setTariffsDialogOpen(true);
  };

  // Save / create the tariff row
  const handleSaveTariff = () => {
    if (!tariffName.trim()) {
      alert("Tariff name is required.");
      return;
    }
    if (!tariffId.trim()) {
      alert("Tariff ID is required.");
      return;
    }
    // Create a new item
    const newTariff = {
      id: parseInt(tariffId, 10) || Math.floor(Math.random() * 9999),
      name: tariffName,
      start: tariffStart,
      end: tariffEnd,
      days: tariffDays
    };
    setTariffsRows([...tariffsRows, newTariff]);
    setTariffsDialogOpen(false);
  };

  // Delete a tariff
  const handleDeleteTariff = (rowId) => {
    setTariffsRows(tariffsRows.filter((tar) => tar.id !== rowId));
  };

  // Example of custom rendering “days” column
  function DaysCell(params) {
    if (!params.value || !Array.isArray(params.value)) return null;
    return (
        <Box sx={{ display: "flex", gap: 1 }}>
          {params.value.map((day) => (
              <Box
                  key={day}
                  sx={{
                    backgroundColor: "#2196f3",
                    color: "#fff",
                    padding: "2px 6px",
                    borderRadius: "4px",
                    fontSize: "0.8rem"
                  }}
              >
                {day}
              </Box>
          ))}
        </Box>
    );
  }

  const renderSettingsTimeGroups = () => (
      <Box sx={{ p: 2 }}>
        <Typography variant="h6">Time groups tab content...</Typography>
      </Box>
  );
  const renderSettingsTariffs = () => {
    const tariffsColumns = [
      {
        field: "name",
        headerName: "Name",
        flex: 1,
        headerAlign: "center",
        align: "center"
      },
      {
        field: "id",
        headerName: "Tariff ID",
        flex: 0.7,
        headerAlign: "center",
        align: "center"
      },
      {
        field: "start",
        headerName: "Start",
        flex: 0.8,
        headerAlign: "center",
        align: "center"
      },
      {
        field: "end",
        headerName: "End",
        flex: 0.8,
        headerAlign: "center",
        align: "center"
      },
      {
        field: "days",
        headerName: "Days",
        flex: 1.5,
        headerAlign: "center",
        align: "center",
        renderCell: DaysCell
      },
      {
        field: "actions",
        headerName: "",
        flex: 0.5,
        sortable: false,
        headerAlign: "center",
        align: "center",
        renderCell: (params) => (
            <IconButton
                sx={{ backgroundColor: "red", color: "#fff" }}
                size="small"
                onClick={() => handleDeleteTariff(params.row.id)}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
        )
      }
    ];

    return (
        <Box sx={{ p: 2, position: "relative" }}>
          <Typography variant="h6" sx={{ mb: 1, color: textColor }}>
            Count: {tariffsRows.length}
          </Typography>

          {/* Floating “+” button */}
          <Box sx={{ position: "absolute", top: 16, right: 16 }}>
            <Fab color="primary" size="medium" onClick={handleAddTariffClick}>
              <AddIcon />
            </Fab>
          </Box>

          <Card sx={{ mt: 2, backgroundColor: cardBgColor }}>
            <CardContent>
              <Box sx={{ height: 400, width: "100%" }}>
                <DataGrid
                    rows={place.placeWindows}
                    columns={tariffsColumns}
                    pageSize={10}
                    rowsPerPageOptions={[10]}
                    getRowId={(row) => row.id} // Make sure to set ID
                    sx={{
                      "& .MuiDataGrid-cell, & .MuiDataGrid-columnHeaderTitle": {
                        color: darkMode ? "#fff" : "#000"
                      },
                      "& .MuiDataGrid-columnHeader": {
                        backgroundColor: darkMode ? "#000" : "#fff"
                      },
                      "& .MuiDataGrid-cell": {
                        color: "#000"
                      }
                    }}
                />
              </Box>
            </CardContent>
          </Card>

          {/* Dialog to add / edit Tariff */}
          <Dialog
              open={tariffsDialogOpen}
              onClose={() => setTariffsDialogOpen(false)}
          >
            <DialogTitle sx={{ color: "#000" }}>Add / Edit Tariff</DialogTitle>
            <DialogContent>
              <TextField
                  label="Name"
                  variant="outlined"
                  fullWidth
                  margin="dense"
                  sx={{
                    "& .MuiInputBase-input": {
                      color: textColor,
                      mb: 2
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                    sx: { color: textColor },
                  }}
                  value={tariffName}
                  onChange={(e) => setTariffName(e.target.value)}
              />
              <TextField
                  label="Tariff ID"
                  variant="outlined"
                  fullWidth
                  margin="dense"
                  sx={{
                    "& .MuiInputBase-input": {
                      color: textColor,
                      mb: 2
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                    sx: { color: textColor },
                  }}
                  value={tariffId}
                  onChange={(e) => setTariffId(e.target.value)}
              />
              <TextField
                  label="Start"
                  variant="outlined"
                  fullWidth
                  margin="dense"
                  sx={{
                    "& .MuiInputBase-input": {
                      color: textColor,
                      mb: 2
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                    sx: { color: textColor },
                  }}
                  value={tariffStart}
                  onChange={(e) => setTariffStart(e.target.value)}
                  placeholder="00:00:00"
              />
              <TextField
                  label="End"
                  variant="outlined"
                  fullWidth
                  margin="dense"
                  sx={{
                    "& .MuiInputBase-input": {
                      color: textColor,
                      mb: 2
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                    sx: { color: textColor },
                  }}
                  value={tariffEnd}
                  margin="dense"
                  onChange={(e) => setTariffEnd(e.target.value)}
                  placeholder="00:00:00"
              />
              {/* Example: let user type days or choose them in checkboxes, etc. */}
              <TextField
                  label="Days (comma‐separated)"
                  variant="outlined"
                  fullWidth
                  margin="dense"
                  value={tariffDays.join(", ")}
                  sx={{
                    "& .MuiInputBase-input": {
                      color: textColor,
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                    sx: { color: textColor },
                  }}
                  onChange={(e) =>
                      setTariffDays(
                          e.target.value.split(",").map((d) => d.trim())
                      )
                  }
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleSaveTariff} color="primary">
                Save
              </Button>
              <Button
                  onClick={() => setTariffsDialogOpen(false)}
                  color="secondary"
                  sx={{backgroundColor: "red", color: "#fff","&:hover": {
                      backgroundColor: "darkred", // Change to a darker red for a nice effect
                    }}}

              >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
    );
  };

  const renderSettingsActions = () => (
      <Box sx={{ p: 2 }}>
        <Typography variant="h6">Actions tab content...</Typography>
      </Box>
  );
  const renderSettingsTasks = () => (
      <Box sx={{ p: 2 }}>
        <Typography variant="h6">Tasks tab content...</Typography>
      </Box>
  );
 function renderSettingsTickets() {
    // State for tickets

    // Filter tickets by search text
    const filteredTickets = ticketsRows.filter((row) => {
      const term = ticketsSearch.toLowerCase();
      return (
          row.id.toLowerCase().includes(term) ||
          row.type.toLowerCase().includes(term) ||
          String(row.value).toLowerCase().includes(term) ||
          String(row.groupId).toLowerCase().includes(term) ||
          row.lastUsed.toLowerCase().includes(term)
      );
    });

    // Columns for DataGrid
    const columns = [
      { field: "id", headerName: "Id", flex: 1 },
      { field: "type", headerName: "type", flex: 1 },
      { field: "value", headerName: "value", flex: 0.6 },
      { field: "groupId", headerName: "group id", flex: 0.6 },
      { field: "lastUsed", headerName: "Last used", flex: 1 },
    ];

    return (
        <Box sx={{ p: 2, position: "relative" }}>
          {/* Search bar */}
          <Box sx={{ mb: 2, maxWidth: 300 }}>
            <TextField
                fullWidth
                placeholder="Search..."
                variant="outlined"
                value={ticketsSearch}
                onChange={(e) => setTicketsSearch(e.target.value)}
                InputProps={{
                  startAdornment: <SearchIcon sx={{ mr: 1 }} />,
                }}
            />
          </Box>

          {/* Count label */}
          <Typography variant="h6" sx={{ mb: 1 }}>
            Count: {filteredTickets.length}
          </Typography>

          {/* Floating action buttons on the right */}
          <Box sx={{ position: "absolute", top: 16, right: 16, display: "flex", gap: 2 }}>
            {/* Blue “tag” button (e.g. for “Add ticket” or “Edit tickets”) */}
            <Fab color="primary" size="medium">
              <LocalOfferIcon />
            </Fab>
            {/* Red “delete” button (bulk delete, etc.) */}
            <Fab color="error" size="medium">
              <DeleteIcon />
            </Fab>
          </Box>

          {/* Data grid */}
          <Card sx={{ mt: 2, backgroundColor: cardBgColor }}>
            <CardContent>
              <Box sx={{ height: 500, width: "100%" }}>
                <DataGrid
                    rows={filteredTickets}
                    columns={columns}
                    // Example: Use the "id" field for unique row IDs
                    getRowId={(row) => row.id}
                    pageSize={10}
                    rowsPerPageOptions={[10, 25, 50]}
                    checkboxSelection
                    sx={{
                      backgroundColor: cardBgColor,
                      "& .MuiDataGrid-cell, & .MuiDataGrid-columnHeaderTitle": {
                        color: darkMode ? "#fff" : "#000",
                      },
                      "& .MuiDataGrid-columnHeader": {
                        backgroundColor: darkMode ? "#000" : "#fff",
                      },
                      "& .MuiDataGrid-cell": {
                        color: "#000",
                      },
                    }}
                />
              </Box>
            </CardContent>
          </Card>
        </Box>
    );
  }
  const renderSettingsUserGroups = () => (
      <Box sx={{ p: 2 }}>
        <Typography variant="h6">User groups tab content...</Typography>
      </Box>
  );

  const handleAddLaneRuleClick = () => {
    setLrName("");
    setLrMembersOnly(false);
    setLrGuestsOnly(true);
    setLrGroup("");
    setLrOperation("block");
    setLrLanes(1);
    setLaneRulesDialogOpen(true);
  };

  // Save a lane rule
  const handleSaveLaneRule = () => {
    if (!lrName.trim()) {
      alert("Please enter a Name for the lane rule.");
      return;
    }
    // If we're always creating (not editing):
    const newId =
        laneRulesRows.length > 0
            ? laneRulesRows[laneRulesRows.length - 1].id + 1
            : 1;
    const newRow = {
      id: newId,
      name: lrName,
      membersOnly: lrMembersOnly,
      guestsOnly: lrGuestsOnly,
      group: lrGroup,
      operation: lrOperation,
      authorizedLanes: parseInt(lrLanes, 10) || 0
    };
    setLaneRulesRows([...laneRulesRows, newRow]);
    setLaneRulesDialogOpen(false);
  };

  function renderLanesTab() {
    // Example columns for “Lane ID”, “Lane Name”, “Direction”, “Actions”
    const lanesColumns = [
      {
        accessorKey: "id",
        header: "Lane ID",
        // Optionally, add a filter function if needed:
        // filterFn: (row, columnId, filterValue) => searchRowRecursively(row, columnId, filterValue),
      },
      {
        accessorKey: "name",
        header: "Lane Name",
      },
      {
        accessorKey: "direction",
        header: "Direction",
      },
      {
        accessorKey: "actions",
        header: "Actions",
        // Custom cell rendering using Material UI's IconButton and MoreVert icon
        Cell: ({ row }) => (
            <IconButton
                size="small"
                color="primary"
                onClick={() => console.log("Lane action for row:", row.original)}
            >
              <MoreVert />
            </IconButton>
        ),
        // You can disable sorting if required:
        enableSorting: false,
      },
    ];

    // Use place.lanes if it’s defined; else an empty array
    const lanesRows = Array.isArray(place?.lanes) ? place.lanes : [];

    return (
        <Card sx={{ mt: 2, backgroundColor: cardBgColor }}>
          <CardHeader
              title="Lanes"
              titleTypographyProps={{
                sx: {
                  color: textColor,
                },
              }}
              sx={{ borderBottom: "1px solid #ccc", color: textColor }}
          />
          <CardContent>
            <Typography variant="body2" sx={{ mb: 2, color: textColor }}>
              Count: {lanesRows.length}
            </Typography>
            <Box sx={{ height: 400, width: "100%" }}>
              <MaterialReactTable
                  data={lanesRows}
                  columns={lanesColumns}
                  enableGlobalFilter
                  muiBottomToolbarProps={{
                    sx: {
                      backgroundColor: darkMode ? '#1e293b' : '#fff',
                      color: darkMode ? '#fff' : '#1e293b',
                      ".MuiFormLabel-root": { color: darkMode ? '#fff' : '#1e293b' },
                      ".MuiSelect-icon": { color: darkMode ? '#fff' : '#1e293b' },
                      ".MuiSelect-select": { color: darkMode ? '#fff' : '#1e293b' },
                      ".MuiBox-root.MuiButtonBase-root": { color: darkMode ? '#fff' : '#1e293b' },
                      ".MuiSvgIcon-root": { color: darkMode ? '#fff' : '#1e293b' },
                      '& .MuiButtonBase-root.Mui-disabled .MuiSvgIcon-root': {
                        color: darkMode ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
                      },
                    },
                  }}
                  muiTopToolbarProps={{
                    sx: {
                      backgroundColor: darkMode ? '#1e293b' : '#fff',
                      color: '#fff',
                      ".MuiSvgIcon-root": { color: darkMode ? '#fff' : '#1e293b' },
                      ".MuiTableSortLabel-iconDirectionAsc": { color: darkMode ? '#fff' : '#1e293b' },
                      '& .MuiInputBase-input': { color: darkMode ? '#fff' : '#1e293b' },
                    },
                  }}
                  muiTableBodyCellProps={{
                    sx: {
                      backgroundColor: darkMode ? "#1e293b" : "#ffffff",
                      color: darkMode ? "#ffffff" : "#000",
                      ".MuiSvgIcon-root": { color: darkMode ? "#ffffff" : "#000" },
                    },
                  }}
                  muiTableHeadCellProps={{
                    sx: {
                      backgroundColor: darkMode ? "#1e293b" : "#0098CF",
                      color: darkMode ? "#ffffff" : "#000",
                      fontWeight: "bold",
                      ".MuiSvgIcon-root": { color: darkMode ? "#ffffff" : "#000" },
                      '& .MuiTableSortLabel-icon': {
                        color: darkMode ? '#fff !important' : '#000 !important',
                      },
                      '& .MuiTableSortLabel-iconDirectionAsc': {
                        color: darkMode ? '#fff !important' : '#000 !important',
                      },
                      '& .MuiTableSortLabel-iconDirectionDesc': {
                        color: darkMode ? '#fff !important' : '#000 !important',
                      },
                      '& .MuiButtonBase-root.Mui-disabled .MuiSvgIcon-root': {
                        color: darkMode ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
                      },
                      '& .MuiInputBase-input': {
                        color: darkMode ? '#fff' : '#1e293b',
                      },
                    },
                  }}
                  globalFilterFn="recursiveSearch"
                  filterFns={{
                    recursiveSearch: (row, columnId, filterValue) =>
                        searchRowRecursively(row, columnId, filterValue),
                  }}
                  muiTableHeadProps={{
                    sx: {
                      display: "table-header-group",
                      backgroundColor: "rgb(0,0,0)",
                      color: "white",
                    },
                  }}
                  initialState={{ expanded: false }}
                  muiTableContainerProps={{
                    sx: {
                      width: "100%",
                      overflowX: "auto",
                      backgroundColor: "#15aff4",
                      color: "white",
                    },
                  }}
              />
            </Box>
          </CardContent>
        </Card>
    );
  }

  // Delete a lane rule
  const handleDeleteLaneRule = (rowId) => {
    setLaneRulesRows(laneRulesRows.filter((r) => r.id !== rowId));
  };

  function renderSettingsLanesRules() {
    // Table columns
    const laneRulesColumns = [
      {
        field: "name",
        headerName: "Name",
        flex: 1.2,
        headerAlign: "center",
        align: "center",
        renderCell: (params) => (
            <Typography
                sx={{ color: "#2196f3", textDecoration: "underline", cursor: "pointer" }}
            >
              {params.value}
            </Typography>
        )
      },
      {
        field: "membersOnly",
        headerName: "Members only",
        flex: 0.8,
        headerAlign: "center",
        align: "center",
        renderCell: (params) => String(params.value) // "true" or "false"
      },
      {
        field: "guestsOnly",
        headerName: "Guests only",
        flex: 0.8,
        headerAlign: "center",
        align: "center",
        renderCell: (params) => String(params.value)
      },
      {
        field: "group",
        headerName: "Group",
        flex: 0.8,
        headerAlign: "center",
        align: "center",
      },
      {
        field: "operation",
        headerName: "Operation",
        flex: 1,
        headerAlign: "center",
        align: "center",
      },
      {
        field: "authorizedLanes",
        headerName: "Authorized lanes",
        flex: 0.8,
        headerAlign: "center",
        align: "center",
        renderCell: (params) => (
            <Typography sx={{ color: "#2196f3", cursor: "pointer" }}>
              {params.value}
            </Typography>
        )
      },
      {
        field: "actions",
        headerName: "",
        flex: 0.4,
        sortable: false,
        headerAlign: "center",
        align: "center",
        renderCell: (params) => (
            <IconButton
                sx={{ backgroundColor: "red", color: "#fff" }}
                size="small"
                onClick={() => handleDeleteLaneRule(params.row.id)}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
        )
      }
    ];

    return (
        <Box sx={{ p: 2, position: "relative" }}>
          {/* The table count */}
          <Typography variant="h6" sx={{ mb: 1, color: textColor }}>
            Count: {laneRulesRows.length}
          </Typography>

          {/* Floating “+” button (to add new lane rule) */}
          <Box sx={{ position: "absolute", top: 16, right: 16 }}>
            <Fab color="primary" size="medium" onClick={handleAddLaneRuleClick}>
              <AddIcon />
            </Fab>
          </Box>

          <Card sx={{ mt: 2, backgroundColor: cardBgColor }}>
            <CardContent>
              <Box sx={{ height: 400, width: "100%" }}>
                <DataGrid
                    rows={laneRulesRows}
                    columns={laneRulesColumns}
                    pageSize={5}
                    rowsPerPageOptions={[5, 10]}
                    getRowId={(row) => row.id}
                    sx={{
                      "& .MuiDataGrid-cell, & .MuiDataGrid-columnHeaderTitle": {
                        color: darkMode ? "#fff" : "#000",
                      },
                      "& .MuiDataGrid-columnHeader": {
                        backgroundColor: darkMode ? "#000" : "#fff",
                      },
                      "& .MuiDataGrid-cell": {
                        color: "#000",
                      },
                    }}
                />
              </Box>
            </CardContent>
          </Card>

          {/* Dialog for adding/editing a lane rule */}
          <Dialog
              open={laneRulesDialogOpen}
              onClose={() => setLaneRulesDialogOpen(false)}
          >
            <DialogTitle sx={{ color: "#000" }}>Add / Edit Lane Rule</DialogTitle>
            <DialogContent>
              <TextField
                  label="Name"
                  fullWidth
                  variant="outlined"
                  margin="dense"
                  sx={{
                    "& .MuiInputBase-input": {
                      color: textColor,
                      mb: 2
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                    sx: { color: textColor },
                  }}
                  value={lrName}
                  onChange={(e) => setLrName(e.target.value)}
              />
              <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
                <FormControlLabel
                    disableTypography
                    sx={{ color: textColor }}
                    control={
                      <Checkbox
                          checked={lrMembersOnly}
                          onChange={() => setLrMembersOnly(!lrMembersOnly)}
                          color="secondary"
                          sx={{ mr: 3, color: textColor}}
                          disableTypography
                      />
                    }
                    label="Members only"
                />
                <FormControlLabel
                    sx={{ color: textColor }}
                    disableTypography
                    control={
                      <Checkbox
                          checked={lrGuestsOnly}
                          onChange={() => setLrGuestsOnly(!lrGuestsOnly)}
                          color="secondary"
                          sx={{ mr: 3, color: textColor }}
                          disableTypography
                      />
                    }
                    label="Guests only"
                />
              </Box>
              <TextField
                  label="Group"
                  fullWidth
                  variant="outlined"
                  sx={{
                    "& .MuiInputBase-input": {
                      color: textColor,
                      mb: 2
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                    sx: { color: textColor },
                  }}
                  value={lrGroup}
                  margin="dense"
                  onChange={(e) => setLrGroup(e.target.value)}
              />
              <FormControl fullWidth variant="outlined" sx={{ mb: 2 }}>
                <InputLabel sx={{color: textColor, marginTop: "10px"}}>Operation</InputLabel>
                <Select
                    value={lrOperation}
                    onChange={(e) => setLrOperation(e.target.value)}
                    label="Operation"
                    sx={{
                      marginTop: "10px",
                      height: "45px",
                      color: textColor,
                      "& .MuiSelect-select": {
                        color: textColor,
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: textColor,
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#1976d2",
                      },
                      "& .MuiSelect-icon": {
                        color: textColor,
                      },
                    }}
                    margin="dense"
                >
                  <MenuItem value="ignoreGraceTimeIn">ignoreGraceTimeIn</MenuItem>
                  <MenuItem value="block">block</MenuItem>
                  <MenuItem value="allow">allow</MenuItem>
                </Select>
              </FormControl>
              <TextField
                  label="Authorized lanes"
                  type="number"
                  fullWidth
                  margin="dense"
                  sx={{
                    "& .MuiInputBase-input": {
                      color: textColor,
                      mb: 2
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                    sx: { color: textColor },
                  }}
                  variant="outlined"
                  value={lrLanes}
                  onChange={(e) => setLrLanes(e.target.value)}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleSaveLaneRule} color="primary">
                Save
              </Button>
              <Button
                  onClick={() => setLaneRulesDialogOpen(false)}
                  color="secondary"
                  sx={{backgroundColor: "red", color: "#fff","&:hover": {
                      backgroundColor: "darkred", // Change to a darker red for a nice effect
                    }}}
              >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
    );
  }

  // Full "Settings" tab with sub‐tabs
  const renderSettingsTab = () => {
    return (
        <Card
            sx={{
              mt: 2,
              backgroundColor: cardBgColor,
              minHeight: 400,
            }}
        >
          {/* Sub‐tabs for Settings */}
          <Tabs
              value={settingsTab}
              onChange={handleSettingsTabChange}
              variant="scrollable"
              scrollButtons="auto"
          >
            <Tab label="General" />
            <Tab label="Organizations" />
            <Tab label="Devices" />
            <Tab label="Time groups" />
            <Tab label="Tariffs" />
            <Tab label="Actions" />
            <Tab label="Tasks" />
            <Tab label="Tickets" />
            <Tab label="User groups" />
            <Tab label="Lanes Rules" />
          </Tabs>

          {/* Sub‐tab content */}
          {settingsTab === 0 && renderSettingsGeneral()}
          {settingsTab === 1 && renderSettingsOrganizations()}
          {settingsTab === 2 && renderSettingsDevices()}
          {settingsTab === 3 && renderSettingsTimeGroups()}
          {settingsTab === 4 && renderSettingsTariffs()}
          {settingsTab === 5 && renderSettingsActions()}
          {settingsTab === 6 && renderSettingsTasks()}
          {settingsTab === 7 && renderSettingsTickets()}
          {settingsTab === 8 && renderSettingsUserGroups()}
          {settingsTab === 9 && renderSettingsLanesRules()}
        </Card>
    );
  };

  // ------------------
  //      RENDER
  // ------------------
  return (
      <DashboardLayout>
        <DashboardNavbar name={place?.name}/>
        <Box sx={{ width: "100%", padding: "20px" }}>
          {/* Main Tabs */}
          <Tabs value={selectedTab} onChange={handleTabChange} textColor="inherit">
            <Tab label="General" />
            <Tab label="Log" />
            <Tab label="Lanes" />
            <Tab label="Users" />
            <Tab label="Places" />
            <Tab label="Settings" />
          </Tabs>

          {/* Content for each main tab */}
          {renderGeneralTab()}
          {selectedTab === 1 && renderLogTab()}
          {selectedTab === 2 && renderLanesTab()}
          {selectedTab === 3 && renderUsersTab()}
          {selectedTab === 4 && renderPlacesTab()}
          {/* SETTINGS TAB (index 4) */}
          {selectedTab === 5 && renderSettingsTab()}
        </Box>
      </DashboardLayout>
  );
}

export default PlaceDetails;
